export const parseExcelPrice = (value: unknown): number | null => {
  if (value == null || value === '' || value === '.') {
    return null;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const normalized = String(value).trim();

  if (!normalized || normalized === '.') {
    return null;
  }

  if (normalized.includes(',') && normalized.includes('.')) {
    return Number(normalized.replace(/\./g, '').replace(',', '.'));
  }

  if (normalized.includes(',')) {
    return Number(normalized.replace(',', '.'));
  }

  const parsed = Number(normalized);

  return Number.isFinite(parsed) ? parsed : null;
};
